module.exports = __webpack_public_path__ + "img/concern-code.431edd23.jpg";